import { resellerService } from '../services'
import Vue from 'vue'

const state = {
  all: {
    filterInitialized: false,
    defaultFilter: {
      name: '',
      organizationNumber: '',
      orderByColumn: 'name',
      orderByDescending: false
    },
    currentPage: 1,
    loading: true,
    saving: false,
    items: [],
    filter: {},
    meta: {}
  }
}

const actions = {
  initialize ({ commit }) {
    commit('initialize')
  },

  resetFilter ({ commit }) {
    commit('resetFilter')
  },

  getAll ({ commit }) {
    return resellerService.getAll()
      .then(
        data => {
          return data.result
        }
      )
  },

  getListData ({ commit }) {
    commit('getListDataRequest')
    return resellerService.getListData(state.all.filter, state.all.currentPage)
      .then(data => {
        commit('getListDataSuccess', data.result)
        return data.result
      })
      .catch(error => {
        if (error) {
          console.error(error)
        }
        // if ($axios.isCancel(error)) {
        //   console.info('Previous request cancelled')
        // } else {
        //   console.error(error)
        // }
      })
  },

  getById ({ commit }, id) {
    return resellerService.getById(id)
  },

  create ({ commit, dispatch }, reseller) {
    commit('startSave')
    return resellerService.create(reseller)
      .then(reseller => {
        commit('endSave')
        commit('createSuccess', reseller.result)
        dispatch('getListData')
        return reseller.result
      }).catch(error => {
        commit('endSave')
        commit('createFailure')
        return Promise.reject(error)
      })
  },

  update ({ commit }, reseller) {
    commit('startSave')
    return resellerService.update(reseller)
      .then(reseller => {
        commit('endSave')
        commit('updateSuccess', reseller.result)
        return reseller
      }).catch(error => {
        commit('endSave')
        commit('updateFailure')
        return Promise.reject(error)
      })
  },

  delete ({ commit }, id) {
    commit('startSave')
    commit('deleteRequest', id)

    resellerService.delete(id)
      .then(reseller => {
        commit('endSave')
        commit('deleteSuccess', id)
      })
      .catch(error => {
        commit('endSave')
        commit('deleteFailure', error)
        return Promise.reject(error)
      })
  }
}

const getters = {
  getStatusName: state => (status) => {
    switch (status) {
      case 'Open':
        return 'Öppen'
    }
  },

  isFilterChanged: state => (route) => {
    // Page should not be considered when comparing
    const currentFilter = Object.assign({}, state.all.filter)
    const defaultFilter = Object.assign({}, state.all.defaultFilter)

    currentFilter.page = null
    defaultFilter.page = null

    return !Vue.lodash.isEqual(currentFilter, defaultFilter)
  }
}

const mutations = {
  resetFilter (state) {
    state.all.currentPage = 1
    state.all.filter = Object.assign({}, state.all.defaultFilter)
  },

  initialize (state) {
    if (!state.all.filterInitialized) {
      mutations.resetFilter(state)
      state.all.filterInitialized = true
    }
  },

  startSave (state) {
    state.all.saving = true
  },

  endSave (state) {
    setTimeout(() => {
      state.all.saving = false
    }, 200)
  },

  getListDataRequest (state) {
    state.all.loading = true
  },

  getListDataSuccess (state, data) {
    state.all.items = data.items
    state.all.meta = data.meta
    state.all.loading = false
  },

  getListDataFailure (state, error) {
    state.all.error = error
    state.all.loading = false
  },

  // Create
  createSuccess (state, updatedReseller) {
    Vue.prototype.$toast('Återförsäljare skapad', 'success')
  },
  createFailure (state, error) {
    Vue.prototype.$toast('Kunde inte skapa återförsäljare', 'error')
  },

  // Update
  updateSuccess (state, updatedCustomer) {
    state.all.items = state.all.items.map(customer =>
      customer.customerId === updatedCustomer.customerId ? updatedCustomer : customer
    )

    Vue.prototype.$toast('Sparat', 'success')
  },
  updateFailure (state) {
    Vue.prototype.$toast('Kunde inte uppdatera återförsäljare', 'error')
  },

  // Delete
  deleteRequest (state, id) {
    // add 'deleting:true' property to customer being deleted
    state.all.items = state.all.items.map(reseller =>
      reseller.resellerId === id
        ? { ...reseller, deleting: true }
        : reseller
    )
  },

  deleteSuccess (state, id) {
    state.all.items = state.all.items.filter(reseller => reseller.resellerId !== id)
  },

  deleteFailure (state, error) {
    Vue.prototype.$toast('Kunde inte ta bort återförsäljare', 'error')
  }
}

export const resellers = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/reseller.module.js